import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { StudentDTO } from 'src/app/demo/model/StudentDTO';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { OperationService } from 'src/app/demo/service/operation.service';
import { Common } from 'src/app/demo/utils/common';
import { WebStorage } from '../../../auth/storage/web.storage';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { RoomDTO } from 'src/app/demo/model/RoomDTO';
import { ITEMS_PER_PAGE } from 'src/app/demo/constants/pagination.constants';
import { Observable, catchError, forkJoin, of } from 'rxjs';
import { StaffDTO } from 'src/app/demo/model/StaffDTO';
import { Dropdown } from 'primeng/dropdown';
import * as moment from 'moment';
import { MasterLookupDTO } from 'src/app/demo/model/MasterLookupDTO';
import { TagDTO } from 'src/app/demo/model/TagDTO';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DashboardSchoolDTO } from 'src/app/demo/model/DashboardSchoolDTO';
import { AttendanceDTO } from 'src/app/demo/model/AttendanceDTO';
import { QuickPanelAttendanceComponent } from 'src/app/demo/sharing/components/quick-panel-attendance/quick-panel-attendance.component';
import { profielBackgroundColor } from 'src/app/demo/sharing/constants/profielBackgroundColor';
// function getCurrentHourAndMinuteIn24HourFormat() {
//   const now = new Date();
//   const hours = now.getHours();
//   const minutes = now.getMinutes();
//   return { hours, minutes };
// }
// const { hours, minutes } = getCurrentHourAndMinuteIn24HourFormat();
// const currentTime24hr = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;

@Component({
  selector: 'app-signin-student',
  templateUrl: './signin-student.component.html',
  styleUrls: ['./signin-student.component.scss']
})
export class SigninStudentComponent {
  userData: any;
  search: any = {};
  pageContext = {
    page: 0,
    previousPage: 0,
    itemsPerPage: 25,
    totalItems: 0,
    sort: 'id,asc',
  };
  roomList: RoomDTO[] = [];
  roomObj: RoomDTO = {};
  tagList: TagDTO[] = [];
  statusList: MasterLookupDTO[] = [];
  selectedRoomId: any;
  selectedTagId: any;
  selectedStatus: any;
  unexpectedStudentNames: any;
  studentList: StudentDTO[] = [];
  selectAllStudents: boolean = false;
  openExpected: boolean = false;
  selectedStudents: any[] = [];
  selectedStudentIds: number[] = [];
  selectedStudentList: any[] = [];
  actualStudList: StudentDTO[] = [];
  studentSearchInput: any;
  signInTime = Common.momentTimeZoneTime(new Date());
  selectedDate = Common.momentTimeZoneDate(new Date());
  // selectedDates: Date = new Date();
  submitForm: boolean = false;
  items!: MenuItem[];
  activeIndex: number = 0;
  studentSignIn !: FormGroup;
  fromOverView: boolean = false;
  staffObj: any;
  roomIds: any;
  today: string = Common.momentTimeZoneDate(new Date());
  isAdminUserLogin: boolean = false;
  backgroundColors: string[] = [];
  constructor(
      private lookupService: LookupService,
      private operationService: OperationService,
      private storage: WebStorage,
      private formBuilder: FormBuilder,
      private messageService: MessageService,

      public ref: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private confirmationService: ConfirmationService,

  ) {
      this.roomObj = this.config.data;
      this.activeIndex = this.config.data.activeIndex;
      this.fromOverView = this.config.data.fromOverView ? true : false;
      this.selectedStudentList = this.config.data.fromOverView ? [...this.config.data.selectedStudents] : [];
      this.selectedStudents = this.config.data.fromOverView ? this.config.data.selectedStudents : [];
      this.selectedStudentIds = this.config.data.fromOverView ? this.config.data.selectedStudentIds : [];
      this.backgroundColors = profielBackgroundColor;
      // this.selectedDates = this.getDefaultDate();
  }
  ngDoCheck(): void {
    // console.log(this.selectedStudentIds, 'selectedStudentIds');
    // console.log(this.selectedStudents, 'selectedStudents');
    // console.log(this.selectedStudentList, 'selectedStudentList');
  }

  ngOnInit(): void {
    this.userData = this.storage.getUserData();
    this.isAdminUserLogin = Common.isAdminUserLogin(this.storage);
    // const currentTime24hr = Common.momentTimeZoneTime(new Date());
    // const currentDate = Common.momentTimeZoneDate(new Date());
    this.items = [
      {
        label: 'Select Students',
        command: (event: any) =>
          this.messageService.add({
            severity: 'info',
            summary: 'First Step',
            key: 'message',
            detail: event.item.label,
            life: 3000,
          }),
      },
      {
        label: 'Confirm Student',
        command: (event: any) =>
          this.messageService.add({
            severity: 'info',
            key: 'message',
            summary: 'Second Step',
            detail: event.item.label,
            life: 3000,
          }),
      },
    ];

    this.studentSignIn = this.formBuilder.group({
      id: ['', []],
      signInTime: ['', [Validators.required]],
      signOutTime: ['', []],
      attendedTime: ['', []],
      signInBy: ['', []],
      signOutBy: ['', []],
      note: ['', []],
      roomId: ['', [Validators.required]],
      status: ['', []],
      schoolId: ['', []],
      staffId: ['', [Validators.required]],
      studentId: ['', []],
      staffName: ['', []],
      hasSignIn: [false, []],
      date: ['', []],
      signInHR: ['', []],
      signInMIN: ['', []],
      signOutHR: [undefined, []],
      signOutMIN: [undefined, []],
    });

    this.getTagData();
    this.getMasterlookupData();
    this.lookupService
      .getStaffById(this.userData.refTableId)
      .subscribe((res: HttpResponse<StaffDTO>) => {
        let temp: StaffDTO = {};
        this.staffObj = res.body ? res.body : temp;
        this.roomIds = [];
        this.selectedRoomId = !Common.isAdminUserLogin(this.storage) ? 
        this.staffObj.primaryRoomId : undefined;
        if (this.staffObj.rooms && this.staffObj.rooms.length > 0) {
          this.roomIds = this.staffObj.rooms
            .filter((room: RoomDTO) => room?.id !== undefined && typeof room.id === 'number')
            .map((room: RoomDTO) => room.id as number);
        }

        if (this.staffObj.primaryRoomId && typeof this.staffObj.primaryRoomId === 'number') {
          this.roomIds.push(this.staffObj.primaryRoomId);
        }
        // this.loadRooms(this.staffObj.primaryRoomId);
        this.getRoomData(this.staffObj.primaryRoomId);
        this.fetchActualStudentList();
        this.queryData();
        this.search = {};
      });
  }
  onDateChange() {
    // const formatted = this.formatDateForApi(this.selectedDates);
    // console.log('Selected date:', this.selectedDate);
    // console.log('Formatted for API:', formatted);
  }

  formatDateForApi(date: Date): string {
    // Strip time manually and format in desired timezone
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();

    const localDate = new Date(year, month, day); // Set time to 00:00:00
    return moment.tz(localDate, 'Asia/Kolkata').format('YYYY-MM-DD');
  }
  onActiveIndexChange(event: number) {
    this.activeIndex = event;
  }

  complete() {
    if (this.selectedStudentIds.length != 0) {
      this.activeIndex = 1;
    } else {
      this.activeIndex = 0;
    }
  }



  prevPage() {
    this.activeIndex = 0;
  }
  handleDateChange(val: string): void {
    if (!val) return;

    const today = moment().startOf('day');
    const selected = moment(val, 'YYYY-MM-DD').startOf('day');

    if (selected.isAfter(today)) {
      this.selectedDate = this.today;
    }
  }
  isButtonDisabled = false;
  onSave() {
    this.isButtonDisabled = true;
    if (Array.isArray(this.selectedStudents)) {
      // Find students who are not expected
      const unexpectedStudents = this.selectedStudents.filter(student => !student.isExpectedToday);
      const studentIds = this.selectedStudents.map((item) => item.id).join(',');
      const formatTo12Hour = (time: string): string => {
        if (!time) return ''; // Handle undefined or null cases
        const [hours, minutes] = time.split(':'); // Extract hours and minutes
        let hour = parseInt(hours, 10);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12 || 12;
        return `${hour.toString().padStart(2, '0')}:${minutes}:00 ${ampm}`; // Add seconds as 00
      };
      const attendanceData: any = {
        id: this.studentSignIn.value.id,
        signInTime: this.signInTime ? formatTo12Hour(this.signInTime) : undefined,
        signOutTime: undefined,
        attendedTime: this.studentSignIn.value.attendedTime,
        signInBy: this.signInTime != undefined ? this.userData.firstName : null,
        signInStaffId: this.userData.refTableId,
        signOutBy: undefined,
        note: this.studentSignIn.value.note,
        hasSignIn: true,
        date: Common.convertLocalDateToUTC(this.selectedDate),
        staffName: this.studentSignIn.value.staffName,
        status: 'A',
        schoolId: this.userData.schoolId,
        hasStudentId: true,
      };    
        
      if (unexpectedStudents.length > 0) {
        // Extract names of unexpected students
        const unexpectedStudentNames = unexpectedStudents.map(student => student.fullName);
        // this.ref.close();
        this.ref.close({ openExpected: true, unexpectedStudentNames, attendanceData, studentIds });
      }
      else {
        this.operationService
          .createAttendanceAll(attendanceData, studentIds)
          .subscribe(
            (res: HttpResponse<AttendanceDTO>) => {
              this.selectedStudentIds = [];
              const messages = {
                severity: 'success',
                life: 3000,
                summary: 'Success',
                detail: `Student Signed In successfully.`,
              };
              this.submitForm = false;
              this.ref.close(messages);
              this.isButtonDisabled = false;
            },
            (error) => {              
              const messages = {
                severity: 'error',
                life: 3000,
                summary: error.error?.title || 'Error',
                detail: error.error?.detail || error.error?.message || error?.message || 'Failed to save attendance'
              };
              this.ref.close(messages);
              this.isButtonDisabled = false;
            }
          );
      }
    }
  }

  protected subscribeToSaveResponse(
    result: Observable<HttpResponse<any>>
  ): void {
    result.subscribe(
      () => this.onSaveSuccess(),
      (error: HttpErrorResponse) => this.onSaveError(error)
    );
  }

  protected onSaveSuccess(): void {
    const messages = {
      severity: 'success',
      life: 3000,
      summary: 'Success',
      detail: `Staff Signed In successfully.`,
    };
    this.submitForm = false;
    this.ref.close(messages);
    this.isButtonDisabled = false;
    this.queryData();
    // this.loadStaff();
  }

  private onSaveError(error: HttpErrorResponse) {
    // this.isClickedOnce = false;
    const newString = error.error.message?.split(".");
    const timeError = newString ? newString[1] : '';
    const substring = "Please sign in during school hours";
    if (timeError == 'incorrectTime') {
      this.messageService.add({
        severity: 'warn',
        life: 3000,
        summary: 'Warning',
        detail: substring
      });
    } else {
      this.messageService.add({
        severity: 'error',
        life: 3000,
      summary: error.error?.title || 'Error',
      detail: error.error?.detail || error.error?.message || error?.message || 'An error occurred'
      });
    }
  }
  queryData() {
    this.search['roomId.notEquals'] = this.roomObj.id != undefined ? this.roomObj.id : undefined;
    this.search.sort = 'fullName,asc';
    if (this.studentSearchInput != undefined) {
      this.search['fullName.contains'] = this.studentSearchInput;
    }
    if (!Common.isAdminUserLogin(this.storage)) {
      delete this.search['id.in'];
      this.search['roomId.equals'] = this.selectedRoomId;
    }
    this.search['profileStatus.equals'] = 'A';
    this.search['status.equals'] = 'A';

    const { startUtc, endUtc } = Common.getUtcDayRange(this.selectedDate);
    this.search['date.greaterThanOrEqual'] = startUtc;
    this.search['date.lessThanOrEqual'] = endUtc;

    this.search['schoolId.equals'] = this.userData.schoolId;
    this.search['roomId.in'] = !Common.isAdminUserLogin(this.storage) ? this.roomIds : undefined;

    if( startUtc !=  undefined && endUtc != undefined){
      Common.removeEmptyFields(this.search);
      this.lookupService.queryStudentsAttendance(this.search)
        .subscribe(async (res: HttpResponse<StudentDTO[]>) => {
          let temp: StudentDTO[] = [];
          this.studentList = res.body ? res.body : temp;
          for (const student of this.studentList) {
            if (student) {
              if (student.photoUuid) {
                this.lookupService.queryDocumentByPhotoUid(student.photoUuid).subscribe((response: HttpResponse<Blob>) => {
                  const body = response?.body;
                  if (body) {
                    const url = this.createImgFromBuffer(body);
                    student.profileimg = url;
                  }
                });
              } else {
                student.profileimg = undefined;
              }
  
            }
          }
        });
    }

    
      
    // this.checkboxChanged();
  }

  fetchActualStudentList() {
    let search :any = {};
    search['status.equals'] = 'A';
    search.sort = 'fullName,asc';

    const { startUtc, endUtc } = Common.getUtcDayRange(this.selectedDate);
    search['date.greaterThanOrEqual'] = startUtc;
    search['date.lessThanOrEqual'] = endUtc;

    search['schoolId.equals'] = this.userData.schoolId;
    search['roomId.in'] = !Common.isAdminUserLogin(this.storage) ? this.roomIds : undefined;
    
    if( startUtc !=  undefined && endUtc != undefined){
      Common.removeEmptyFields(search);
      this.lookupService.queryStudentsAttendance(search).subscribe((res: HttpResponse<StudentDTO[]>) => {
        let temp: StudentDTO[] = [];
        this.actualStudList = res.body ? res.body : temp;
      });
    }

  }
  getTagData() {
    this.search = {};
    this.search['status.equals'] = 'A';
    this.search.sort = 'name,asc';
    this.search.size = 500;
    this.search['schoolId.equals'] = this.userData.schoolId;
    Common.removeEmptyFields(this.search);
    this.lookupService
      .queryTag(this.search)
      .subscribe((res: HttpResponse<TagDTO[]>) => {
        let temp: TagDTO[] = [];
        this.tagList = res.body ? res.body : temp;
      });
  }

  getRoomData(roomId: any) {
    this.search = {};
    this.search['sort'] = 'name,asc'
    this.search['status.equals'] = 'A';
    this.search.size = 500;
    this.search['id.notEquals'] = this.roomObj.id;
    this.search['schoolId.equals'] = this.userData.schoolId;
    if (!Common.isAdminUserLogin(this.storage)) {
      this.search['id.in'] = this.roomIds;
      this.selectedRoomId = this.selectedRoomId ? this.selectedRoomId : roomId;
    }
    Common.removeEmptyFields(this.search);
    this.lookupService
      .queryRooms(this.search)
      .subscribe((res: HttpResponse<RoomDTO[]>) => {
        let temp: RoomDTO[] = [];
        this.roomList = res.body ? res.body : temp;
      });
  }

  getMasterlookupData() {
    this.lookupService
      .queryMasterLookups({
        size: 10,
        'type.equals': 'Profile Status',
        'value.notEquals': 'I',
        sort: 'id,asc',
      })
      .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
        let temp: MasterLookupDTO[] = [];
        this.statusList = res.body ? res.body : temp;
      });
  }

  createImgFromBuffer(blob: Blob) {
    const url = URL.createObjectURL(blob);
    return url;
  }
  onClear() {
    this.studentSearchInput = [];
    this.selectedRoomId = undefined;
    this.selectedTagId = [];
    this.selectedStatus = [];
    this.selectedStudents = [];
    this.actualStudList = [];
    this.selectedStudentIds = [];
    this.selectAllStudents = false;
    this.filter();
    this.filterRoom();
    this.filterTag();
    this.filterStatus();
    this.queryData();
  }

  filter() {
    let filtered: StudentDTO[] = [];

    if (this.studentSearchInput.length !== 0) {
      for (let i = 0; i < this.studentList.length; i++) {
        let user = this.studentList[i];
        if (
          user?.fullName &&
          (user.fullName.toLowerCase().indexOf(this.studentSearchInput.toLowerCase()) === 0 ||
            user.fullName.toLowerCase().includes(this.studentSearchInput.toLowerCase()))
        ) {
          filtered.push(user);
        }
      }
    } else {
      filtered = [...this.actualStudList];
    }

    this.studentList = [...filtered];
    this.checkboxChanged();
  }

  // filterRoom() {
  //   let filtered: StudentDTO[] = [];
  //   if (this.selectedRoomId != undefined) {
  //     for (let i = 0; i < this.studentList.length; i++) {
  //       let user = this.studentList[i];
  //       if (user?.roomId && (user.roomId == this.selectedRoomId)) {
  //         filtered.push(user);
  //       }
  //     }
  //   } else {
  //     filtered = [...this.actualStudList];
  //   }

  //   this.studentList = [...filtered];
  //   this.checkboxChanged();
  // }
  filterRoom() {
    if (this.selectedRoomId != undefined) {
      this.studentList = this.actualStudList.filter(user => user?.roomId === this.selectedRoomId);
    } else {
      this.studentList = [...this.actualStudList];
    }
    this.checkboxChanged();
  }

  filterTag() {
    let filtered: StudentDTO[] = [];
    if (this.selectedTagId.length === 0) {
      filtered = [...this.actualStudList];
    } else {
      // Create a Set for more efficient lookup
      const selectedTagSet = new Set(this.selectedTagId);

      filtered = this.actualStudList.filter(user =>
        user?.tags?.length &&
        user.tags.some(tag =>
          // Check if current tag id matches any selected tag
          selectedTagSet.has(tag.id)
        )
      );
    }

    this.studentList = [...filtered];
    this.checkboxChanged();
  }

  filterStatus() {
    let filtered: StudentDTO[] = [];
    if (this.selectedStatus.length === 0) {
      filtered = [...this.actualStudList];
    } else {
      const selectedStatusSet = new Set(this.selectedStatus);

      filtered = this.actualStudList.filter(user =>
        user?.profileStatus && selectedStatusSet.has(user.profileStatus)
      );
    }

    this.studentList = [...filtered];
    this.checkboxChanged();

  }

  onRemoveStud(event: Event, stud: any) {
    this.confirmationService.confirm({
      key: 'confirm2',
      target: event.target as EventTarget,
      message: `Do you want to Remove ${stud.fullName}?`,
      acceptButtonStyleClass: 'p-button-primary p-button-raised',
      rejectButtonStyleClass: 'p-button-secondary p-button-outlined',
      defaultFocus: 'none',
      accept: () => this.deleteStudents(stud),
      reject: () => { },
    });
  }

  deleteStudents(stud: any) {
    try {
      if (!stud || !stud.id) {
        throw new Error('Invalid student data');
      }

      if (!this.selectedStudentList || !this.selectedStudentIds || !this.selectedStudents || !this.studentList) {
        throw new Error('Required arrays are not initialized');
      }

      const indexToRemove = this.selectedStudentList.findIndex(
        (student) => student.id === stud.id
      );
      if (indexToRemove !== -1) {
        this.selectedStudentList = this.selectedStudentList.filter(
          student => student.id !== stud.id
        );
      }

      this.selectedStudentIds = this.selectedStudentIds.filter(
        id => id !== stud.id
      );

      this.selectedStudents = this.selectedStudents.filter(
        student => student.id !== stud.id
      );

      this.selectedStudentList = [...this.selectedStudents];

      const mainListStudent = this.studentList.find(
        student => student.id === stud.id
      );
      if (mainListStudent) {
        mainListStudent.selected = false;
      }

      this.selectAllStudents = false;
      this.submitForm = false;

      this.messageService.add({
        key: 'message',
        severity: 'success',
        life: 3000,
        summary: 'Success',
        detail: 'Student Removed Successfully'
      });

    } catch (error) {
      console.error('Error in deleteStudents:', error);
      this.messageService.add({
        key: 'message',
        severity: 'error',
        life: 3000,
        summary: 'Error',
        detail: error instanceof Error ? error.message : 'Failed to remove student'
      });
    }
  }

  toggleSelection(student: any) {
    const index = this.selectedStudents.findIndex(
      (selected) => selected.id === student.id
    );
    if (index !== -1) {
      this.selectedStudents.splice(index, 1);
    } else {
      this.selectedStudents.push(student);
    }
    this.selectedStudentIds = this.selectedStudents.map(
      (selected) => selected.id
    );

    this.selectedStudentList = [...this.selectedStudents];

  }

  isSelected(student: StudentDTO): boolean {
    return this.selectedStudents.includes(student);
  }

  toggleAllSelection() {
    this.studentList.forEach(
      (student) => (student.selected = this.selectAllStudents)
    );

    if (this.selectAllStudents) {
      this.selectedStudents = [...this.studentList];
    } else {
      this.selectedStudents = [];
    }
    this.selectedStudentIds = this.selectedStudents.map(
      (selected) => selected.id
    );

    this.selectedStudentList = [...this.selectedStudents];

  }

  checkboxChanged() {
    if (this.studentList && this.studentList?.length !== 0) {
      if (this.isAllSelected()) this.selectAllStudents = true;
      else this.selectAllStudents = false;
    } else {
      this.selectAllStudents = false;
    }
  }

  isAllSelected(): boolean {
      return this.studentList.every((student) => student.selected);
  }

  getBackgroundColor(studentId: any) {
      if (!studentId) return this.backgroundColors[0];
      const index = (studentId - 1) % this.backgroundColors.length;
      return this.backgroundColors[index];
  }

  getInitials(fullName?: string): string {
      if (!fullName?.trim()) return '';
      const words = fullName.trim().split(/[-\s]+/);
      const firstLetter = words[0]?.[0]?.toUpperCase() || '';
      const secondLetter = words[1]?.[0]?.toUpperCase() || '';
      return `${firstLetter}${secondLetter}`.trim();
  }

  getAttenStatus(student: any) {
      if (student?.isSignedIn) {
          return 'Student is signed in';
      } else if (student?.isAbsent) {
          return 'Student is absent';
      } else if (student?.profileStatus == 'Upcoming') {
          return 'Student is upcoming';
      } else if (student?.profileStatus == 'I') {
          return 'Student is inactive';
      }
      return '';
  }
}
